import {
  RUNNER_PLAYER_HITBOX_SCALE,
  RUNNER_PLAYER_SPRITE_WIDTH_S,
  RUNNER_REF_VIEWBOX_WIDTH,
} from './runnerConstants';
import type { RunnerHitbox, RunnerLevel, RunnerPlayer } from './runnerTypes';

function spriteScaleS(viewBoxWidth: number): number {
  return viewBoxWidth / RUNNER_REF_VIEWBOX_WIDTH;
}

export function computeRunnerPlayerHitbox(level: RunnerLevel, player: RunnerPlayer): RunnerHitbox {
  const scaleS = spriteScaleS(level.viewBox.width);
  const sizeS = RUNNER_PLAYER_SPRITE_WIDTH_S * scaleS * RUNNER_PLAYER_HITBOX_SCALE;
  return {
    centerS: player.worldS,
    centerLane: player.lane,
    widthS: sizeS,
    heightLane: sizeS / level.viewBox.height,
  };
}
